<div class="col-md-12 mb-30" [hidden]="View_Partition!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات درخواست تعمیر</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" (click)="Set_View_Partition('Form')"  type="button" class="btn btn-success" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Group</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>ناریخ</th>
              <th>کاربر</th>
              <th>وضیعت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa).length
                      }
            ">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td>{{item.groupTitle}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>{{item.dsc}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a class="dropdown-item" style="cursor: pointer;" (click)="Set_DeviceBehfa_Record(item)"><i class="fa fa-eye"></i>
                        مشاهده </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_DeviceBehfaTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<app-DeviceBehfaRepairForm
  [inner_DeviceBehfa]="Data_Seleted_DeviceBehfa"
  (OnBack_DeviceBehfaRepairForm)="OnSet_Back_ShowList($event)"
  *ngIf="View_Partition=='Form'"></app-DeviceBehfaRepairForm>
